<div class="loading-container">
  <mat-spinner></mat-spinner>

  <h1>{{ "loading" | transloco }}...</h1>
</div>
